import { special } from 'valibot';

import type { DealerTypeAbbr } from './types';
import { isDealerTypeAbbr } from './utils';

export const dealerTypeAbbrSchema = special<DealerTypeAbbr>(
  isDealerTypeAbbr,
);
